import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual'
}

function scrollWindowToTop() {
  window.scrollTo(0, 0)
  document.documentElement.scrollTop = 0
  document.body.scrollTop = 0
}

const ScrollToTop = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    scrollWindowToTop()
  }, [pathname])

  useEffect(() => {
    scrollWindowToTop()

    const handlePageShow = () => {
      scrollWindowToTop()
    }

    window.addEventListener('pageshow', handlePageShow)
    return () => window.removeEventListener('pageshow', handlePageShow)
  }, [])

  return null
}

export default ScrollToTop
